import React from 'react';
import '../styles/header.scss';
import NavBar from "./navBar";

function Header() {

    return (
        <>
        <div className="header">
            <NavBar/>
        </div>
        </>
    )
}
export default Header;